import(/* webpackMode: "eager", webpackExports: ["AboutHeader"] */ "/vercel/path0/app/about/sections/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/.pnpm/next@15.2.8_react-dom@19.0.0_react@19.0.0__react@19.0.0/node_modules/next/dist/client/app-dir/link.js");
